import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useStore } from "../context/Store";

export const CartSheet = () => {
  const { cart, cartOpen, setCartOpen, setQty, subtotal, fmt } = useStore();
  const nav = useNavigate();
  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent className="w-full sm:max-w-md bg-[#FAF7F2] flex flex-col" data-testid="cart-sheet">
        <SheetHeader><SheetTitle className="font-display text-2xl">Your basket</SheetTitle></SheetHeader>
        {cart.length === 0 ? (
          <div className="flex-1 grid place-items-center text-center text-stone-500" data-testid="cart-empty">
            <div><ShoppingBag className="w-12 h-12 mx-auto mb-3 text-[#C85A32]/50" />Your basket is empty</div>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto space-y-3 py-4">
              {cart.map((i) => (
                <div key={i.id} data-testid={`cart-item-${i.id}`} className="flex gap-3 bg-white p-3 rounded-xl">
                  <img src={i.image} alt="" className="w-16 h-16 rounded-lg object-cover" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm line-clamp-2">{i.title}</p>
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center gap-2">
                        <button data-testid={`cart-dec-${i.id}`} onClick={() => setQty(i.id, i.qty - 1)} className="w-7 h-7 rounded-full border grid place-items-center hover:bg-stone-100"><Minus className="w-3 h-3" /></button>
                        <span className="text-sm font-semibold w-5 text-center">{i.qty}</span>
                        <button data-testid={`cart-inc-${i.id}`} onClick={() => setQty(i.id, i.qty + 1)} className="w-7 h-7 rounded-full border grid place-items-center hover:bg-stone-100"><Plus className="w-3 h-3" /></button>
                      </div>
                      <span className="font-bold text-sm">{fmt(i.price_usd * i.qty)}</span>
                      <button data-testid={`cart-remove-${i.id}`} onClick={() => setQty(i.id, 0)} className="text-stone-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t pt-4 space-y-3">
              <div className="flex justify-between font-semibold"><span>Subtotal</span><span data-testid="cart-subtotal">{fmt(subtotal)}</span></div>
              <button data-testid="cart-checkout-btn" onClick={() => { setCartOpen(false); nav("/checkout"); }} className="w-full h-12 rounded-full bg-[#C85A32] text-white font-semibold hover:bg-[#A9481F] transition-colors">Checkout</button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
